import React from 'react';
import './Footer.css';

export const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>SnapIT Suite</h3>
          <ul>
            <li><a href="https://snapitsoftware.com" target="_blank" rel="noopener noreferrer">SnapIT Software</a></li>
            <li><a href="https://snapitforms.com" target="_blank" rel="noopener noreferrer">SnapIT Forms</a></li>
            <li><a href="https://snapitanalytics.com" target="_blank" rel="noopener noreferrer">SnapIT Analytics</a></li>
            <li><a href="https://snapitagent.com" target="_blank" rel="noopener noreferrer">SnapIT Agent</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Tools & Utilities</h3>
          <ul>
            <li><a href="https://burn.snapitsoftware.com" target="_blank" rel="noopener noreferrer">SnapIT Burn</a></li>
            <li><a href="https://pollpixie.com" target="_blank" rel="noopener noreferrer">Poll Pixie</a></li>
            <li><a href="https://qrcheetah.com" target="_blank" rel="noopener noreferrer">QR Cheetah</a></li>
            <li><a href="https://urlunicorn.com" target="_blank" rel="noopener noreferrer">URL Unicorn</a></li>
            <li><a href="https://httptiger.com" target="_blank" rel="noopener noreferrer">HTTP Tiger</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><a href="https://docsdingo.com" target="_blank" rel="noopener noreferrer">Docs Dingo</a></li>
            <li><a href="https://forumfly.app" target="_blank" rel="noopener noreferrer">Forum Fly</a></li>
            <li><a href="https://dms.snapitsoftware.com" target="_blank" rel="noopener noreferrer">Dead Man's Switch</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Legal & Support</h3>
          <ul>
            <li><a href="/terms">Terms of Service</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/feedback">Send Feedback</a></li>
          </ul>
          <p className="footer-description">
            Secure, self-destructing file sharing. Files automatically delete after viewing.
          </p>
          <p className="footer-copyright">
            &copy; 2026 SnapIT Software. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
